import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { accessVerify, capitalize } from '../../../utils/common';
import PermissionRequired from '../../errorPages/permissionRequired';
import { getLeaveBalance } from '../../../redux/slices/hrRedux/UserManagementRedux/userLeaveRedux';

export default function LeaveBalance() {
  const { themeStretch } = useSettings();
  const [leaveBalance, setLeaveBalance] = useState([]);
  let selectedLocation;
  ({ selectedLocation } = useSelector((state) => state.location));
  const { balance } = useSelector((state) => state.leave);

  useEffect(() => {
    dispatch(getLeaveBalance(selectedLocation?.id));
  }, [selectedLocation?.id]);

  useEffect(() => {
    setLeaveBalance(balance);
  }, [balance]);

  const columns = !leaveBalance?.[0]
    ? []
    : Object.keys(leaveBalance?.[0])
        .map((value) => {
          if ([''].includes(value)) {
            return {};
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);

  return (
    <Page title={`Leave Balance`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs heading={`Leave Balance`} links={[{ name: 'Dashboard', href: PATH_DASHBOARD.root }, { name: 'HR', href: '' }, { name: `Leave Balance` }]} action={<></>} />

        {accessVerify('GENERAL_DATA') ? (
          <DataGridTable
            name={'Leave Balance'}
            data={leaveBalance}
            column={columns}
            isLoading={false}
            onRowClick={(row) => {}}
            isRowClickable={true}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableRowSelection={false}
            enableRowActions={false}
            renderRowActionItems={(value, closeMenu) => []}
          />
        ) : (
          <PermissionRequired />
        )}
      </Container>
    </Page>
  );
}
